import { FC, memo } from 'react'

import { IconName } from 'ui/components'

import { TableButtonProps } from './TableButtonProps'

import * as SC from './styles'

export const TableButton: FC<TableButtonProps> = memo((props) => {
  const { children, face = 'neutral', 'data-qa': dataQA, ...rest } = props

  const data_qa = typeof children === 'string' && !dataQA ? children : dataQA

  const isPositive = face === 'positive'
  const isWarning = face === 'warning'
  const isDander = face === 'danger'
  const isNeutral = face === 'neutral'
  const isEdit = face === 'edit'
  const isDelete = face === 'delete'

  return (
    <>
      {isPositive && (
        <SC.Positive data-qa={data_qa} {...rest}>
          <SC.Inner>{children}</SC.Inner>
        </SC.Positive>
      )}
      {isWarning && (
        <SC.Warning data-qa={data_qa} {...rest}>
          <SC.Inner>{children}</SC.Inner>
        </SC.Warning>
      )}
      {isDander && (
        <SC.Dander data-qa={data_qa} {...rest}>
          <SC.Inner>{children}</SC.Inner>
        </SC.Dander>
      )}
      {isNeutral && (
        <SC.Neutral data-qa={data_qa} {...rest}>
          <SC.Inner>{children}</SC.Inner>
        </SC.Neutral>
      )}
      {isEdit && (
        <SC.Edit data-qa={dataQA || 'edit-table-button'} {...rest}>
          <SC.IconWrapper name={IconName.EDIT} />
        </SC.Edit>
      )}
      {isDelete && (
        <SC.Delete data-qa={dataQA || 'delete-table-button'} {...rest}>
          <SC.IconWrapper name={IconName.TRASH_OUTLINE} />
        </SC.Delete>
      )}
    </>
  )
})
